import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { AppService } from '../../../app.service';
import {
    DashboardPageConstants,
    DashboardFavourites,
    CrackHistory,
    MonthHeader
} from './dashboard.model';
import { SearchFilters } from './search-panel/search-panel.model';
import { FavouriteDialogComponent } from '../favourite-dialog/favourite-dialog.component';
import { GETDashboardService } from '../dashboard/dashboard.service';
import { MatDialog } from '@angular/material/dialog'; import { ToastrService } from 'ngx-toastr';
import { NotificationsService } from 'angular2-notifications';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { DigitalFormUserAlertComponent } from '../digital-form-search/digital-form-user-alert/digital-form-user-alert.component';
import { PreferencesService } from '../../preferences/preferences.service';
import { MatTabChangeEvent } from '@angular/material/tabs/tab-group';
import { DashBoardModule } from '../../../../app/shared/enums/allEnums';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [
        trigger(
            'enterAnimation', [
            transition(':enter', [
                style({ height: '1px', opacity: 0 }),
                animate('250ms', style({ height: '324px', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: '324px', opacity: 1 }),
                animate('250ms', style({ height: '1px', opacity: 0 }))
            ])
        ]
        )],
})
export class DashboardComponentGET implements OnInit {
    // Page constants
    pageConstants: DashboardPageConstants = new DashboardPageConstants();

    // Search options
    searchParameters: SearchFilters = new SearchFilters();
    showSearch: boolean = true;
    hideFavourites: boolean = false;

    // Get from server
    performSearch: boolean = false;
    userFavorites: DashboardFavourites[] = [];
    selectedUserFavourites: DashboardFavourites[] = [];

    searchResults: SearchFilters[] = [];
    selectedTab = 0;
    onEq: number = 3;

    performSearchImp: boolean = false;
    performAssetLocationHxSearchImp: boolean = false;
    emptyFav: boolean = false

    showGraphBar: boolean = false;
    showGraphIcon: boolean = false
    onCrack: number = 1

    showEqViewTab: boolean = false;
    showAssetLocationTab: boolean = false;
    showCrackTab: boolean = false;
    showAssetTab: boolean = false;
    implementIDList: number[] = []
    numberofNotifications: number
    EnableDashboardAlerts: boolean = false
    showText: boolean = false;
    crackData: CrackHistory[] = [];
    months: MonthHeader[] = [];
    selectedMonths: number = 3;
    tabReplace: boolean = false;
    @Input() searchParameters_: SearchFilters = new SearchFilters();

    constructor(private _pref: PreferencesService, private _dialog: MatDialog, private _favouriteDialogService: FavouriteDialogService, private _appService: AppService,
        private _dashboardService: GETDashboardService,
        public dialog: MatDialog,
        private notification: ToastrService,
        public toastr: NotificationsService, vcr: ViewContainerRef,) {
    }

    ngOnInit() {
        this.getUserAlertsforDashbpard();
        this.getReplaceExistingTabStatus();
        let values = window.location.href;
        let val = values.includes('/get/dashboard');

        if (val == true) {
            this.showEqViewTab = false
            this.showCrackTab = true;
            this.showAssetLocationTab = true;
            this.showAssetTab = true;

        } else {
            this.showEqViewTab = true;
            this.showCrackTab = true;
            this.showAssetLocationTab = false;
            this.showAssetTab = false;
        }
        this._appService.setPageTitle(this.pageConstants.PAGE_TITLE);
        this._pref.GetDashBoardAlertEnableStatus().subscribe(res => {
            if (res == "True") {
                this.EnableDashboardAlerts = true;
            } else {
                this.EnableDashboardAlerts = false;
            }
        });
        this.loadFavourites();
    }

    getReplaceExistingTabStatus() {
        this._pref.GetReplaceExistingTabStatus().subscribe(res => {
            this.tabReplace = res;
        }, error => {
            console.log("Error fetching replace existing tab status:", error);
        });
    }

    onTabChange(event: MatTabChangeEvent) {
        if (event.tab.textLabel === 'ASSET LOCATION HISTORY') {
            this.performAssetLocationHxSearchImp = true;
        }
        if (event.tab.textLabel === 'CRACK VIEW') {
            this.performSearchImp = true;
        }
    }

    getOnEquipment() {
        //this.onEq
        //console.log("Chages", this.onEq)
    }

    loadFavourites() {
        this._dashboardService.GetDashboardFavourites().subscribe(result => {
            if (result != null) {
                this.userFavorites = result;
            }
        });
    }

    showFavorite(favourite) {
        console.log("this.before", this.selectedUserFavourites.length, this.hideFavourites, this.performSearchImp)
        console.log("this.before array", this.selectedUserFavourites)
        console.log("favourite", favourite)
        let hasValue = this.selectedUserFavourites.find(x => x.Id == favourite.Id);
        var index = this.selectedUserFavourites.indexOf(favourite.Id);
        this.selectedUserFavourites.splice(index, 1)
        this.selectedUserFavourites.push(favourite);
        this.emptyFav = true;
        this.performSearchImp = false;

        // if(!hasValue){

        //this.selectedUserFavourites.push(favourite);
        // this.emptyFav=true;
        //this.performSearchImp=false;          
        // this.selectedUserFavourites= favourite         
        // }
        this.hidematgroup = false;
    }
    deleteFavorite(favourite) {
        if (favourite.Id > 0) {
            this._dashboardService.DeleteFavourite(favourite.Id).subscribe(res => {
                if (res) {

                    this.toastr.success("Deleted successfully");
                    this.loadFavourites();
                } else {
                    console.log("failed")
                }
            })
        }

    }
    show: boolean = false
    hidematgroup: boolean = false


    ResetFields(value) {
        this.hidematgroup = value;
        this.selectedUserFavourites = [];
    }
    toggleFavourites() {
        this.hideFavourites = !this.hideFavourites;
    }

    showSearchPanel(visibility: boolean) {
        this.showSearch = visibility;
    }

    getSearchFilters(data: any) {
        this.searchParameters = data;
        console.log("searchParameters:", this.searchParameters);
        //this.searchParameters.onEq=this.onEq;
        this.performSearch = true;
        this.performSearchImp = true;
        this.hidematgroup = false;
        if (this.searchResults.length == 1 && this.searchParameters !== undefined && this.searchParameters != null) {
            this.searchResults.pop();
            this.searchResults.push(this.searchParameters);
        } else if (this.searchResults.length == 0 && this.searchParameters !== undefined && this.searchParameters != null) {
            this.searchResults.push(this.searchParameters);
        }
        //show graph icon
        this.showGraphIcon = this.searchResults.length > 0 ? true : false;
        console.log('tab', this.selectedTab);
        if (this.selectedTab == 2)
            this.searchParameters = { ...this.searchParameters };
    }

    OpenFavourite(): void {
        let dialogRef = this.dialog.open(FavouriteDialogComponent, {
            disableClose: true,
            data: {}
        });
        dialogRef.afterClosed().subscribe(r => {
            this.loadFavourites();
            if (!r) return;
        });
    }



    UpdateFavourite(favourite: any) {
        let dialogRef = this.dialog.open(FavouriteDialogComponent, {
            disableClose: true,
            data: {
                favouriteId: favourite.Id
            }
        });
        dialogRef.afterClosed().subscribe(r => {
            if (r.data != null) {
                this.loadFavourites();
            } else {

            }
        });
    }
    showGraphsBar() {
        this.showGraphBar = !this.showGraphBar
    }

    showAlertDialog() {
        const dialogRef = this._dialog.open(DigitalFormUserAlertComponent, {
            data: {
            ModuleId: DashBoardModule.GET
            }
        });
        dialogRef.afterClosed().subscribe(res => {
            console.log("res", res)
            this.getUserAlertsforDashbpard();

        });
    }

    getUserAlertsforDashbpard() {
        this._favouriteDialogService.getCurrentUserAlertsforDigitalForms(DashBoardModule.GET).subscribe(res => {
            console.log(res)

            this.numberofNotifications = res.filter(x => x.status == 1).length

            if (this.numberofNotifications == 0) {
                this.showText = false;
            } else {
                this.showText = true;
            }

        })
    }

    // getCrackView() {
    //     const payload = {
    //       ...this.searchParameters,
    //       Level: 1,
    //       Months: this.selectedMonths
    //     };
    //     this._dashboardService.GetCrackView(payload).subscribe({
    //       next: (res) => {
    //         this.months = res.Months;
    //         this.crackData = res.Data;
    //         console.log("crack view data", res);
    //       },
    //       error: (error) => {
    //         console.log("crack error data", error);
    //       }
    //     });
    // }
}
